import React, { useEffect, useState, useContext, useMemo } from "react";
import "./SupplierDashboard.scss";
import { withTranslation } from "react-i18next";
import { RegulationContext, CompanyContext } from "../../../App";
import Utils from "../../../core/utilities/Utils";
import SupplierDashboardListBox from "../SupplierDashboardBox/SupplierDashboardListBox";
import RiskClassificationBox from "../RiskClassificationBox/RiskClassificationBox";
import { startYear, currentYear } from "../../../core/constants/common";

const SupplierDashboard = ({ t }) => {
  // All hooks must be called first, in the same order every render
  const { glbRegulation} =   useContext(RegulationContext);
  const { glbCompany, setGlbCompany } = useContext(CompanyContext);
  const [annualyear, setAnnualYear] = useState(new Date().getFullYear());
  
  // Initialize profileId synchronously from localStorage to match original behavior
  const [profileId] = useState(() => {
    try {
      const lsDat = JSON.parse(localStorage.getItem("authority"));
      return lsDat?.profile?.company?.id || null;
    } catch (error) {
      return null;
    }
  });
  
  // Memoize year options to avoid recreating on every render
  const options = useMemo(() => {
    const yearOptions = [];
    for (let i = currentYear; i >= startYear; i--) {
      yearOptions.push(<option value={i} key={i}>{i}</option>);
    }
    return yearOptions;
  }, []);

  useEffect(() => {
    // getProfileData();
    const getRisk = () => {
      const lsDat = JSON.parse(localStorage.getItem("authority"));
      if (!lsDat?.profile?.company?.id) return;
      
      let selCompanyContext = glbCompany?.companyId > 0 ? glbCompany.companyId : '';
      let reg = glbRegulation?.id;
      let companyId = lsDat.profile.company.id;
      var string = Utils.generateUrlParamCompanyRegulationWithSupplier(
        selCompanyContext,
        reg,
        companyId
      );
    };
    getRisk();
  }, [glbRegulation, glbCompany, annualyear]);
  return (
    <div className="SupplierDashboard">
      <div className="List_header">
        <div className="d-flex flex-row bd-highlight mb-3"></div>
        <div className="List_sorts_menu">
          <div className="d-flex justify-content-end">
            <ul>
              <li>
                <select
                  className="form-select"
                  required
                  value={annualyear}
                  onChange={(e) => {
                    setAnnualYear(e.target.value);
                  }}
                >
                  {options}
                </select>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row m-0">
        <div className="col-md-6 p-2">
          <SupplierDashboardListBox type="TASK" annualyear={annualyear} />
        </div>
        <div className="col-md-6 p-2">
          <SupplierDashboardListBox type="FORM" annualyear={annualyear} />
        </div>

        {glbCompany?.companyId > 0 && (
          <div className="col-md-6 p-2">
            <div className="card card-box01">
              <div className="card-box01_head">
                <h6>{t("MyRisk.label")}</h6>
              </div>
              <div className="card-box01_body">
                <RiskClassificationBox
                  profileId={profileId}
                  annualyear={annualyear}
                />
              </div>
            </div>
          </div>
        )}
        {!glbCompany?.companyId && (
          <div className="col-md-6 p-2">
            <SupplierDashboardListBox type="HIGH_RISK_COMPANIES" annualyear={annualyear} />
          </div>
        )}
        <div className="col-md-6 p-2">
          <SupplierDashboardListBox type="INCIDENT" annualyear={annualyear} />
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(SupplierDashboard);
